import React from 'react';

export default function Header() {
  return (
    <div className="header">
      <div className="tracking-in-expand">
        <span className="title-poke">Poké</span>Memory
      </div>
    </div>
  );
}
